import i18n from '@/app/i18n';
import { apiErrorCode, apiErrorHolder } from '@/lib/apiErrorCode';
import { humanizeError } from '@/lib/errors';

/**
 * Смена почты ученика в правке (28.09.2026, разбор удобства админки №2, договор `admin-email-change.md`).
 *
 * ⚠️ ЧТО БЫЛО. Поле «Почта» уходило в users-service вместе с именем и телефоном, а тот его молча выбрасывал: админ
 * видел «Сохранено», почта оставалась прежней. Адрес живёт в auth — теперь он уходит туда отдельным вызовом и только
 * когда изменился.
 */
export function emailChanged(before: string | undefined, after: string | undefined): boolean {
  return (after ?? '').trim() !== (before ?? '').trim();
}

/**
 * Отказ смены почты словами. «Адрес занят» — с именем учётки, у которой он есть (решение владельца 28.09): без имени
 * админ не поймёт, что ученика уже заводили. Остальное — общим разбором (причину «адрес не подходит» сервер отдаёт
 * словами).
 */
export function emailChangeError(err: unknown): string {
  if (apiErrorCode(err) === 'email_taken') {
    const holder = apiErrorHolder(err);
    const name = holder?.full_name.trim();
    if (!name) return i18n.t('studentForm.emailTakenNoName');
    return holder?.status === 'deleted'
      ? i18n.t('studentForm.emailTakenDeleted', { name })
      : i18n.t('studentForm.emailTaken', { name });
  }
  return humanizeError(err);
}
